import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'underscore';
import { VF_BUTTON_SELECTOR } from 'AppSrc/core/components/forms/form-base-components/v-f-button-selector';
import { VF_DROPDOWN } from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown';
import { VF_TEXTAREA } from 'AppSrc/core/components/forms/form-base-components/v-f-textarea';
import { VF_INPUT } from 'AppSrc/core/components/forms/form-base-components/v-f-input';
import { VF_MULTI_SELECT } from 'AppSrc/core/components/forms/form-base-components/v-f-multi-select';
import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';
import { VF_TIME_STAMP } from 'AppSrc/core/components/forms/form-base-components/utility/v-f-time-stamp';
import { VF_DATE_PICKER } from 'AppSrc/core/components/forms/form-base-components/v-f-date-picker';
import { VF_MODAL } from 'AppSrc/core/components/forms/form-base-components/v-f-modal';
import { VF_RADIO_BUTTON } from 'AppSrc/core/components/forms/form-base-components/v-f-radio-button';
import {
  INLINE_ERRORS,
  MODAL_ERRORS,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  formSectionShape,
  formDataShape,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import { currentSelectedNetwork, getIsInternationalCrq, getIsOlaCrq } from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
// import { OloParameters } from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/field-parameter-map';
import { SummaryVFDatePicker } from 'AppSrc/core/components/forms/form-base-components/summary-components/summary-v-f-date-picker';
import { SummaryVFButtonSelector } from './summary-v-f-button-selector';
import { SummaryVFDropdown } from './summary-v-f-dropdown';
import { SummaryVFMultiSelect } from './summary-v-f-multi-select';
import { SummaryVFTextarea } from './summary-v-f-textarea';
import { SummaryVFModal } from './summary-v-f-modal';
import { SummaryVFInput } from './summary-v-f-input';
import { SectionSummaryHeader } from './section-summary-header';

// this can be displayed differently depending on the type of input.
const summaryFieldTypes = {
  [VF_BUTTON_SELECTOR]: SummaryVFButtonSelector,
  // NOTE: VF_DROPDOWN uses SummaryVFButtonSelector as a temporary measure. SummaryVFButtonSelector works for simple
  // drop downs, but in future we will have to make SummaryVFDropdown to handle the more complex data structures
  // for NameCards ect
  [VF_DROPDOWN]: SummaryVFDropdown,
  [VF_TEXTAREA]: SummaryVFTextarea,
  [VF_INPUT]: SummaryVFInput,
  [VF_MODAL]: SummaryVFModal,
  [VF_DATE_PICKER]: SummaryVFDatePicker,
  [VF_MULTI_SELECT]: SummaryVFMultiSelect,
  // coming soon!
  [VF_TIME_STAMP]: null, // This is only used in work information item at the moment, might never need a summary component
  [VF_RADIO_BUTTON]: null, // NOT FULLY IMPLEMENTED YET!
  // this is not really a form field!
  [VF_SUB_SECTION_TITLE]: null,
};

const SectionSummary = React.memo(({
  formSection,
  sectionIndex,
  navigateToSection,
  open,
  toggleOpen,
  sectionErrors,
  summarySectionRead,
  viewType,
  hasErrors,
  selectedNetwork,
  formData,
  // assign,
  changeAnalystCircuitCheckID, // adding for graying out the button
  userLoggedIn, // adding for graying out the button
  network, // for use in rescheduling
  impactValue, // for use in rescheduling
  hasReferenceCRQ,
}) => {
  const {
    sectionTitle,
    dataByFieldId,
    fieldIdsByDisplayOrder,
    sectionId,
  } = formSection;

  const {
    otherLineOperator,
  } = formData;

  const isIcmCrq = getIsInternationalCrq(formData);
  const isOloCrq = getIsOlaCrq(formData);
  const sectionHasErrors = hasErrors ? !isEmpty(sectionErrors) : false;
  let showNote = false;
  const currenNetwork = currentSelectedNetwork(formData);
  if (((formData.status === '3') || (formData.status === '4')) && network === 'fixed' && (otherLineOperator === 'No')) {
    showNote = true;
  }
  else if (sectionId === 'APPROVERS_SECTION' && currenNetwork === 'fixed' && otherLineOperator === undefined) {
    showNote = true;
  }
  // console.log('Form Data', formData, 'impact value', impactValue);
  // removing the field id from formdata if the section doesnt require that field id, fo eg outage window from section 3 for impact 1/2
  const newfieldIdsByDisplayOrder = sectionTitle === '3. Scheduled start/end date' && (impactValue === 1 || impactValue === 2) ? fieldIdsByDisplayOrder.filter((item) => item !== 'outage_start_date' && item !== 'outage_end_date') : fieldIdsByDisplayOrder;
  // removing customer ompact assesment for risklevel 1&2 causing emeregency
  const newfieldIdsByDisplayOrderUpdated = sectionTitle === '4. Change details' && (formData.riskValue === 'Risk Level 1' || formData.riskValue === 'Risk Level 2') ? newfieldIdsByDisplayOrder.filter((item) => item !== 'customer_impact_statement') : newfieldIdsByDisplayOrder;

  return (
    <div className="section-summary">
      <SectionSummaryHeader
        open={open}
        toggleOpen={toggleOpen}
        sectionIndex={sectionIndex}
        navigateToSection={navigateToSection}
        sectionTitle={sectionTitle}
        sectionId={sectionId}
        viewType={viewType}
        summarySectionRead={summarySectionRead}
        sectionHasErrors={sectionHasErrors}
        formData={formData} // Sending FormData as extra props to SectionSummaryHeader    Component
        // assign={assign}
        changeAnalystCircuitCheckID={changeAnalystCircuitCheckID}
        userLoggedIn={userLoggedIn}
        impactValue={impactValue} // sending for rescheduling changes
        network={network} // sending for rescheduling changes
        hasReferenceCRQ={hasReferenceCRQ}
      />
      {
        open && (
          <ul className="summary-fields">
            {
              newfieldIdsByDisplayOrderUpdated.map((fieldId) => {
                const fieldData = dataByFieldId[fieldId];
                const isCreateCRQ = window.location.href.includes('create');
                let Hidefield = false;
                if (otherLineOperator === 'Yes') {
                  Hidefield = fieldId + sectionId + otherLineOperator === 'timingCHANGE_QUESTIONSYes' ? true : false;
                }
                if (otherLineOperator === 'No') {
                  Hidefield = fieldId + sectionId + otherLineOperator === 'timingCHANGE_TYPENo' ? true : false;
                }
                // To hide the Change Summary section one & section two redundent questions
                if ((['mobile', 'fixed'].includes(currenNetwork) || isIcmCrq === true) || isCreateCRQ && !isOloCrq) {
                  Hidefield = sectionId === 'CHANGE_TYPE' && (fieldId === 'olo_req_international_services' || fieldId === 'timing') ? true : false;
                }
                if (isOloCrq) {
                  Hidefield = sectionId === 'CHANGE_QUESTIONS' && fieldId === 'timing' ? true : false;
                }
                const {
                  fieldType,
                  hideFromSummary,
                  vFTypeSpecificOptions,
                  value,
                } = fieldData;
                const FieldSummary = summaryFieldTypes[fieldType];
                if (hideFromSummary) {
                  return null;
                }

                if (!FieldSummary) {
                  return null;
                }
                if (!value) {
                  return null;
                }
                const error = sectionErrors ? sectionErrors[fieldId] : null;

                let inlineErrors = [];
                let modalErrors = [];

                if (error) {
                  inlineErrors = error[INLINE_ERRORS] ? error[INLINE_ERRORS] : [];
                  modalErrors = error[MODAL_ERRORS] ? error[MODAL_ERRORS] : [];
                }

                const inlineErrorMessage = inlineErrors.length > 0 ? inlineErrors.join('. ') : null;

                return (
                  <li className="summary-field" style={{ display: Hidefield ? 'none' : '' }} key={fieldId}>
                    <FieldSummary
                      fieldData={fieldData}
                      selectedNetwork={selectedNetwork}
                      formData={formData}
                    />
                    {
                      inlineErrorMessage && (
                        <div className={`summary-error-inline summary-error-${fieldType}`}>
                          <span>
                            {inlineErrorMessage}
                          </span>
                        </div>
                      )
                    }
                    {
                      modalErrors.length > 0 && (
                        <div className={`summary-error-modal summary-error-${fieldType}`}>
                          <span className="moadal-error-message-title">
                            {vFTypeSpecificOptions.modalErrorsTitle}
                          </span>
                          <ul className="moadal-error-messages">
                            {
                              modalErrors.map((errorMessage) => (
                                <li key={errorMessage}>
                                  <p className="moadal-error-message">
                                    {`- ${errorMessage}`}
                                  </p>
                                </li>
                              ))
                            }
                          </ul>
                        </div>
                      )
                    }
                  </li>
                );
              })
            }
            {
              showNote === true && sectionIndex === 6 && (
                <p className="note-p">Note: Initially added approver will only be visible once CRQ is moved in to Approval stage.</p>
              )
            }
          </ul>
        )
      }
    </div>
  );
});


SectionSummary.propTypes = {
  formSection: formSectionShape,
  formData: formDataShape,
  sectionIndex: PropTypes.number,
  navigateToSection: PropTypes.func,
  open: PropTypes.bool,
  toggleOpen: PropTypes.func,
  sectionErrors: PropTypes.objectOf(PropTypes.object),
  summarySectionRead: PropTypes.bool,
  viewType: PropTypes.string,
  hasErrors: PropTypes.bool,
  selectedNetwork: PropTypes.string,
  // assign: PropTypes.bool,
  userLoggedIn: PropTypes.string,
  changeAnalystCircuitCheckID: PropTypes.string,
  impactValue: PropTypes.string,
  network: PropTypes.string,
  hasReferenceCRQ: PropTypes.bool,
};



export { SectionSummary };
